/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * One document row on the buyer-facing transaction surface.
 * 
 * Deliberately narrower than ``MtxDocResponse``: the buyer gets only what
 * identifies a file and lets them fetch it. Withheld: ``uploaded_by_id``
 * (reviewer/uploader identity), ``doc_category`` (internal taxonomy),
 * ``status`` / ``is_executed`` / review + signature state, ``storage_path``,
 * ``source`` / ``external_id`` / ``source_metadata`` (provenance pointers),
 * the Documenso envelope + template ids, ``received_from_party``,
 * ``deadline_at`` / ``contingency_type``, and ``is_confidential``.
 * 
 * Read off ``transaction_buyer_documents`` — the submission record — not off the
 * ``mtx_docs`` row, so ``file_name`` and ``doc_type`` are what the buyer sent rather
 * than what an operator has since retitled or retyped the shared row to.
 * 
 * ``id`` is the submission record's own id, which is what the download route addresses.
 * NOT the ``mtx_docs`` id: same-typed files from one buyer share a single ``mtx_docs``
 * row, so a doc id names a SET of files and every entry in a multi-file submission would
 * carry the same download link.
 * @export
 * @interface PublicTransactionDocumentResponse
 */
export interface PublicTransactionDocumentResponse {
    /**
     * 
     * @type {string}
     * @memberof PublicTransactionDocumentResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PublicTransactionDocumentResponse
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof PublicTransactionDocumentResponse
     */
    docType?: string;
    /**
     * 
     * @type {Date}
     * @memberof PublicTransactionDocumentResponse
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the PublicTransactionDocumentResponse interface.
 */
export function instanceOfPublicTransactionDocumentResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "createdAt" in value;

    return isInstance;
}

export function PublicTransactionDocumentResponseFromJSON(json: any): PublicTransactionDocumentResponse {
    return PublicTransactionDocumentResponseFromJSONTyped(json, false);
}

export function PublicTransactionDocumentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicTransactionDocumentResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fileName': json['file_name'],
        'docType': !exists(json, 'doc_type') ? undefined : json['doc_type'],
        'createdAt': (new Date(json['created_at'])),
    };
}

export function PublicTransactionDocumentResponseToJSON(value?: PublicTransactionDocumentResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'file_name': value.fileName,
        'doc_type': value.docType,
        'created_at': (value.createdAt.toISOString()),
    };
}

